import { HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DailyStagingPayListFilter } from '@app/modules/inventory/models';
import { CrudService, CrudType, CustomDirectiveConfig, datePipeConversion,getPDropdownData,IApplicationResponse, ModulesBasedApiSuffix, onActionSubmittedUtil, PERMISSION_RESTRICTION_ERROR,  prepareGetRequestHttpParams,prepareRequiredHttpParams,ResponseMessageTypes, RxjsService, SERVER_REQUEST_DATE_TRANSFORM, SnackbarService} from '@app/shared';
import { InventoryModuleApiSuffixModels, INVENTORY_COMPONENT } from '@modules/inventory/shared';
import { forkJoin } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { Store } from '@ngrx/store';
import { AppState } from '@app/reducers';
import { handleNgrxStoreData, processStoreData } from '@app/shared/utils/combine-page-level.utils';
@Component({
  selector: 'app-daily-staging-pay-list',
  templateUrl: './daily-staging-pay-list.component.html',
  styleUrls: ['./daily-staging-pay-list.component.scss']
})
export class DailyStagingPayListComponent extends PrimeNgTableVariablesModel {

  stagingReportFilterForm: FormGroup;
  showFilterForm = false;
  warehouseList = [];
  referenceNumberList = [];
  receivingBarCodeList = [];
  stockCodeList = [];
  dateFormat = 'MMM dd, yyyy';
  startTodayDate = 0;
  otherParams;
  isANumberOnly = new CustomDirectiveConfig({ isANumberOnly: true, });
  constructor(private commonService: CrudService,private snackbarService:SnackbarService,private router: Router,private formBuilder: FormBuilder,private activatedRoute: ActivatedRoute,
    private rxjsService: RxjsService,private store: Store<AppState>) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Daily Staging Bay Report",
      breadCrumbItems: [{ displayName: 'Inventory Management', relativeRouterUrl: '' }, { displayName: 'Daily Staging Bay Report' },{ displayName: 'Automated' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Automated',
            dataKey: 'stagingBayReportId',
            enableBreadCrumb: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            enableAction: true,
            enableExportBtn: true,
            enablePrintBtn: true,
            printTitle: 'Daily Staging Bay Report',
            printSection: 'print-section0',
            columns: [{ field: 'reportId', header: 'Report ID' }, { field: 'warehouse', header: 'Warehouse' },
            { field: 'quantity', header: 'Quantity', validateInput: this.isANumberOnly }, { field: 'reportDate', header: 'Report date',isDateTime:true }],
            shouldShowFilterActionBtn: true,
            isDateWithTimeRequired: true,
            apiSuffixModel: InventoryModuleApiSuffixModels.DAILY_STAGING_PAY_REPORT,
            moduleName: ModulesBasedApiSuffix.INVENTORY,
          },
          {
            caption: 'Manual',
            dataKey: 'stagingBayReportId',
            enableBreadCrumb: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            enableHyperLink: true,
            enableAction: true,
            enableExportBtn: true,
            enablePrintBtn: true,
            printTitle: 'Daily Staging Bay Report',
            printSection: 'print-section',
            cursorLinkIndex: 0,
            shouldShowFilterActionBtn: true,
            isDateWithTimeRequired: true
          }
        ]
      }
    }
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.selectedTabIndex = (Object.keys(params['params']).length > 0) ? +params['params']['tab'] : 0;
      this.primengTableConfigProperties.selectedTabIndex = this.selectedTabIndex;
      this.primengTableConfigProperties.breadCrumbItems[2].displayName = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption;
    });
  }

  ngOnInit(): void {
    handleNgrxStoreData((response) => {
      let processData = processStoreData(response, this.primengTableConfigProperties, INVENTORY_COMPONENT.DAILY_STAGING_BAY_REPORT);
      this.primengTableConfigProperties = processData.primengTableConfigProperties
      this.loggedInUserData = processData.loggedInUserData
    }, this.store);
    this.getRequiredListData();
    this.createstagingReportFilterForm();
  }

  getRequiredListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    otherParams = {...otherParams,...{UserId: this.loggedInUserData.userId}}
    this.otherParams = otherParams;
    let InventoryModuleApiSuffixModels: InventoryModuleApiSuffixModels;
    InventoryModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    this.commonService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize,otherParams )
    ).subscribe(data => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.dataList =  data.resources;
        this.totalRecords = data.totalCount;
      } else {
        data.resources = null;
        this.dataList =  data.resources
        this.totalRecords = 0;
      }
    })
  }

  onTabChange(event) {
    if (event.index == 1) {
      this.router.navigate(['/inventory', 'daily-staging-bay', 'add-edit'], {});
      return false;
    }
    this.row = {}
    this.dataList = [];
    this.totalRecords = null;
    this.selectedTabIndex = event.index
    this.router.navigate(['/inventory/daily-staging-bay'], { queryParams: { tab: this.selectedTabIndex } })
    this.getRequiredListData();
  }

  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: any): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.row = row;
        this.first = row["pageIndex"] && row["pageSize"] ? row["pageIndex"] * row["pageSize"] : 0;
        this.getRequiredListData(row["pageIndex"], row["pageSize"], unknownVar)
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.FILTER:
        this.displayAndLoadFilterData();
        break;
      case CrudType.EXPORT:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canExport) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
         }
        let pageIndex =  this.row && this.row ["pageIndex"] ?  this.row ["pageIndex"]:0;
        let pageSize  =  this.row && this.row["pageSize"] ? this.row["pageSize"] : 10;
        this.exportList(pageIndex,pageSize );
        break;
      default:
    }
  }
  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string, index?: number): void {
    switch (type) {
      case CrudType.CREATE:
        break;
      case CrudType.VIEW:
        this.router.navigate(['/inventory', 'daily-staging-bay', 'view'], {
          queryParams: {
            id: editableObject['stagingBayReportId']
          }, skipLocationChange: true
        });
        break;
    }
  }

  displayAndLoadFilterData() {
    this.showFilterForm = !this.showFilterForm;
    this.warehouseList = [];
    this.referenceNumberList = [];
    forkJoin([
      this.commonService.dropdown(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_WAREHOUSE,prepareRequiredHttpParams({ userId: this.loggedInUserData?.userId })),
      this.commonService.dropdown(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.UX_PURCHASEORDER_SEARCH),
    ]).subscribe((response: IApplicationResponse[]) => {
      response.forEach((resp: IApplicationResponse, ix: number) => {
        if (resp.isSuccess && resp.statusCode === 200) {
          switch (ix) {
            case 0:
              this.warehouseList = getPDropdownData(resp.resources);
              break;
            case 1:
              this.referenceNumberList = getPDropdownData(resp.resources);
              break;
          }
        }
      })
      this.rxjsService.setGlobalLoaderProperty(false);
    })

  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
}

  createstagingReportFilterForm(stagingPayListModel?: DailyStagingPayListFilter) {
    let DailyStagingPayListModel = new DailyStagingPayListFilter(stagingPayListModel);
    this.stagingReportFilterForm = this.formBuilder.group({});
    Object.keys(DailyStagingPayListModel).forEach((key) => {
      if (typeof DailyStagingPayListModel[key] === 'string') {
        this.stagingReportFilterForm.addControl(key, new FormControl(DailyStagingPayListModel[key]));
      }
    });
    // Subscribe to fromDate changes to clear toDate if fromDate becomes greater than toDate
    this.stagingReportFilterForm.get('fromDate').valueChanges.subscribe((fromDate: Date) => {
      if (fromDate) {
        const toDateControl = this.stagingReportFilterForm.get('toDate');
        if (toDateControl.value && toDateControl.value < fromDate) {
          toDateControl.setValue(null);
        }
      }
    });
  }

  getSelectedReferenceNumber(reference): void {
    this.receivingBarCodeList = [];
    if (reference?.value.length != 0) {
      let params = new HttpParams().set('PurchaseOrderIds', reference?.value?.join(","));
      this.commonService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.RECEIVING_BARCODE_LIST, undefined, true, params).subscribe((response: IApplicationResponse) => {
        if (response.resources && response.statusCode === 200) {
          this.receivingBarCodeList = getPDropdownData(response.resources);
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
    }
  }

  getSelectedRecevingBarcode(stockCode): void {
    this.stockCodeList = [];
    if (stockCode?.value.length != 0) {
      let params = new HttpParams().set('OrderReceiptBatchIds', stockCode?.value?.join(","));
      this.commonService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.STAGING_STOCK_CODE_LIST, undefined, true, params).subscribe((response: IApplicationResponse) => {
        if (response.resources && response.statusCode === 200) {
          this.stockCodeList = getPDropdownData(response.resources);
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
    }
  }

  submitFilter() {
    let data = Object.assign({},
      this.stagingReportFilterForm.get('warehouseId').value == '' ? null : { WarehouseIds: this.stagingReportFilterForm.get('warehouseId').value },
      this.stagingReportFilterForm.get('referenceNumberId').value == '' ? null : { PurchaseOrderIds: this.stagingReportFilterForm.get('referenceNumberId').value },
      this.stagingReportFilterForm.get('receivingBarcodeId').value == '' ? null : { OrderReceiptBatchIds: this.stagingReportFilterForm.get('receivingBarcodeId').value },
      this.stagingReportFilterForm.get('fromDate').value == '' ? null : { FromDate: datePipeConversion(this.stagingReportFilterForm.get('fromDate').value, SERVER_REQUEST_DATE_TRANSFORM) },
      this.stagingReportFilterForm.get('toDate').value == '' ? null : { ToDate: datePipeConversion(this.stagingReportFilterForm.get('toDate').value, SERVER_REQUEST_DATE_TRANSFORM) },
      this.stagingReportFilterForm.get('stockCodeId').value == '' ? null : { ItemIds: this.stagingReportFilterForm.get('stockCodeId').value }, { UserId: this.loggedInUserData.userId }
    );
    Object.keys(data).forEach(key => {
      if (data[key] == "" || data[key] == null) {
        delete data[key]
      }
  });
    this.getRequiredListData('', '', data);
    this.showFilterForm = !this.showFilterForm;
  }

  resetForm() {
    this.stagingReportFilterForm.reset();
    this.getRequiredListData('', '', null);
    this.showFilterForm = !this.showFilterForm;
  }
  exportList(pageIndex?: any, pageSize?: any, otherParams?: object) {
    let queryParams;
    queryParams = this.generateQueryParams(otherParams,pageIndex,pageSize);
    let exportapi =  InventoryModuleApiSuffixModels.DAILY_STAGING_PAY_EXPORT
    let label = 'Daily Staging Bay Automated';
    this.commonService.downloadFile(ModulesBasedApiSuffix.INVENTORY,
      exportapi,null, null, queryParams).subscribe((response: any) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (response) {
          this.saveAsExcelFile(response, label);
          this.rxjsService.setGlobalLoaderProperty(false);
        }
    });
  }
  generateQueryParams(otherParams,pageIndex,pageSize) {

    let queryParamsString;
    queryParamsString = new HttpParams({ fromObject:this.otherParams })
    .set('pageIndex',pageIndex)
    .set('pageSize',pageSize);

     queryParamsString.toString();
     return queryParamsString;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

}
